import React from "react";
import _ from "lodash";

function warnDeprecation() {
  if (process.env.NODE_ENV === "development") {
    console.warn(
      "InaccessibleLink is deprecated. Please use button and style it as a link"
    );
    console.warn(
      "See https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/anchor-is-valid.md."
    );
  }
}

const _warnDeprecation = _.debounce(warnDeprecation, 500);

function InaccessibleLink(props) {
  // Note that this component allows us to use <a> tags
  // without proper href and still pass linters. Note that this
  // is an accessibility violation that should be fixed ASAP by
  // moving to use <buttons> instead of <a>. This is
  // unforunately complicated by how we rely on bootstrap
  // for certain functionality, which expects a <a> tag.
  _warnDeprecation();
  const { children, ...rest } = props;
  return <a {...rest}>{children}</a>;
}

export default InaccessibleLink;
